import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import Avatar from '@bubble-ui/molecule-avatar';
import { useDesignContext } from '@klarna/designtokens';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import View from '@bubble-ui/primitive-view';
import Image from '@bubble-ui/primitive-image';
import { defaultDesignTokens } from './defaultDesignTokens';
var BORDER_WIDTH = 1;
var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    isAvatar,
    size,
    hasBorderTop
  } = _ref;
  return {
    containerStyle: _objectSpread(_objectSpread({
      borderRadius: size / 2
    }, isAvatar ? {} : {
      backgroundColor: 'white'
    }), {}, {
      width: size,
      height: size,
      overflow: 'hidden'
    }, !isAvatar && hasBorderTop ? {
      borderWidth: 1,
      borderColor: designContext.get('dialog/box-shadow-color').toString()
    } : {}),
    borderStyle: {
      position: 'absolute',
      opacity: 0.5,
      top: size / 2,
      bottom: 0,
      width: size,
      height: size / 2,
      borderBottomLeftRadius: size / 2 + BORDER_WIDTH,
      borderBottomRightRadius: size / 2 + BORDER_WIDTH,
      borderColor: designContext.get('dialog/box-shadow-color').toString(),
      borderWidth: BORDER_WIDTH,
      borderTop: 0
    },
    imageStyle: {
      objectFit: 'contain',
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    }
  };
};
var DialogIconComponent = _ref2 => {
  var {
    hasBorderTop: hasBorderTopProp,
    size,
    source
  } = _ref2;
  var designContext = useDesignContext(defaultDesignTokens);
  var isAvatar = typeof source !== 'string';
  var {
    containerStyle,
    borderStyle,
    imageStyle
  } = getDefaultStyleSheet({
    designContext,
    isAvatar,
    size,
    hasBorderTop: hasBorderTopProp
  });
  // the default value for hasBorderTop has to be set after generating styles
  // to keep things looking the same, because it was like that before recompose removal
  var hasBorderTop = hasBorderTopProp || true;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(View, {
    style: containerStyle
  }, isAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    large: true,
    icon: source
  }) : /*#__PURE__*/React.createElement(Image, {
    source: source,
    style: imageStyle
  })), !isAvatar && !hasBorderTop && /*#__PURE__*/React.createElement(View, {
    style: borderStyle
  }));
};
var DialogIcon = withProvisionalOverrideFromContext(DialogIconComponent);
DialogIcon.displayName = 'DialogIcon';
export { DialogIcon };
//# sourceMappingURL=DialogIcon.js.map